import React, { Component } from 'react'
import { CFButton, CFSelect, CFInput } from 'cf-web-app/components'
import * as utils from 'cf-utils'
import { dispatch } from 'cf-web-app/store'
import { ThemeContext } from 'cf-web-app'

export default class UserDetails extends Component {
  state = {
    edit: '',
  }
  nameInput = React.createRef()
  phoneInput = React.createRef()
  render() {
    return (
      <ThemeContext.Consumer>
        {({ Components, User }) => (
          <User.UserDetailsView
            email={<CFSelect selector={dispatch.user.getEmail} />}
            name={<CFSelect selector={dispatch.user.getName} />}
            NameInputElement={
              <CFSelect selector={dispatch.user.getName}>
                {name =>
                  this.state.edit === 'name' ? (
                    <CFInput
                      ref={this.nameInput}
                      maxLength="18"
                      defaultValue={name}
                      onKeyPress={this._handleKeyPress}
                      {...User.nameInputProps}
                    />
                  ) : (
                    <User.UserDetailsTextView
                      text={name ? name : 'Update Name'}
                    />
                  )
                }
              </CFSelect>
            }
            PhoneNumberInputElement={
              <CFSelect selector={dispatch.user.getPhoneNumber}>
                {phoneNumber =>
                  this.state.edit === 'phone' ? (
                    <CFInput
                      ref={this.phoneInput}
                      maxLength="10"
                      defaultValue={phoneNumber}
                      onKeyPress={this._handleKeyPress}
                      {...User.phoneNumberInputProps}
                    />
                  ) : (
                    <User.UserDetailsTextView
                      text={utils.formatPhoneNumber(phoneNumber)}
                    />
                  )
                }
              </CFSelect>
            }
            edit={this.state.edit}
            CancelEditButtonElement={
              <CFButton onClick={() => this.setState({ edit: '' })}>
                <Components.CancelButtonView />
              </CFButton>
            }
            SaveNameButtonElement={
              <CFButton onClick={() => this._handleButtonClick('saveName')}>
                <Components.CheckButtonView />
              </CFButton>
            }
            SavePhoneNumberButtonElement={
              <CFButton onClick={() => this._handleButtonClick('savePhone')}>
                <Components.CheckButtonView />
              </CFButton>
            }
            EditNameButtonElement={
              <CFButton onClick={() => this._handleButtonClick('name')}>
                <Components.EditButtonView />
              </CFButton>
            }
            EditPhoneNumberButtonElement={
              <CFButton onClick={() => this._handleButtonClick('phone')}>
                <Components.EditButtonView />
              </CFButton>
            }
            PaymentRowElement={
              <CFSelect selector={dispatch.user.getHasPayment}>
                {hasPayment =>
                  hasPayment && (
                    <User.UserDetailsPaymentView
                      last4={<CFSelect selector={dispatch.user.getLast4} />}
                      EditCCButtonElement={
                        <CFButton
                          onClick={() => this._handleButtonClick('payment')}
                        >
                          <Components.EditButtonView />
                        </CFButton>
                      }
                    />
                  )
                }
              </CFSelect>
            }
          />
        )}
      </ThemeContext.Consumer>
    )
  }
  _handleKeyPress = e => {
    if (e.key === 'Enter') {
      this._handleButtonClick('save')
    }
  }
  _handleButtonClick = name => {
    const { history } = this.props
    if (name === 'name') {
      this.setState({ edit: 'name' })
    } else if (name === 'phone') {
      this.setState({ edit: 'phone' })
    } else if (name === 'saveName') {
      const userName = this.nameInput.current.value
      if (userName.length === 0) {
        dispatch.notification.setMessage({
          message: 'Name cannot be empty!',
          level: 'success',
        })
        return
      }
      dispatch.user
        .changeUserInfo({ name: userName })
        .then(() => {
          dispatch.notification.setMessage({
            message: 'User Info Saved!',
            level: 'success',
          })
        })
        .catch(e => {
          dispatch.notification.setMessage({
            message: e.message,
            level: 'error',
          })
        })
      this.setState({ edit: '' })
    } else if (name === 'savePhone') {
      const phoneNumber = this.phoneInput.current.value
      dispatch.user
        .changeUserInfo({ phoneNumber })
        .then(() => {
          dispatch.notification.setMessage({
            message: 'User Info Saved!',
            level: 'success',
          })
        })
        .catch(e => {
          dispatch.notification.setMessage({
            message: e.message,
            level: 'error',
          })
        })
      this.setState({ edit: '' })
    } else if (name === 'payment') {
      history.push('/payment/user')
    }
  }
}
